import guestAxios from "@/utils/guestAxios";

export const guestRequestsApi = {
  create: (payload) => {
    return guestAxios.post("/api/GuestRequests/Create", payload);
  },
};
